import * as Yup from 'yup';

export const validate = Yup.object().shape({
    nombre: Yup.string().required('campo obligatorio'),
    descripcion: Yup.string().required('campo obligatorio'),
    miniatura: Yup.object({}).required('campo obligatorio').nullable(),
    fondo: Yup.object({}).required('campo obligatorio').nullable(),
    titulo: Yup.string().required('campo obligatorio'),
    informacion: Yup.string().required('campo obligatorio'),
    color: Yup.string().required('campo obligatorio'),
     botones: Yup.array().of(
    Yup.object()
      .shape({
        nombre: Yup.string().required('campo obligatorio'),
        url: Yup.string().nullable(),
        archivo: Yup.mixed().nullable(),
        estilo: Yup.string().required('campo obligatorio'),
      })
      .test(
        'url-o-archivo',
        'Debe ingresar una URL o subir una imagen/archivo',
        function (value) {
          const hasUrl = !!value?.url?.trim();
          const hasArchivo =
            !!value?.archivo &&
            typeof value.archivo === 'object' &&
            Object.keys(value.archivo).length > 0;

          if (hasUrl || hasArchivo) return true;

          return this.createError({
            path: `${this.path}.url`,
            message: 'Debe ingresar una URL o subir una imagen/archivo',
          });
        }
      )
  )
});